/**
 * Help Documentation Links Configuration
 * Centralized location for all Growth99 help center documentation URLs
 */

export const HELP_DOCS = {
  /**
   * Main Help Center
   */
  HELP_CENTER: 'https://help.growth99.com/knowledge-base/release-notes',
  //TODO: Update the above Urls once available
  REFER_A_PRACTICE: '',
  SUPPORT_TICKETS: '',

  /**
   * Review Manager Documentation
   */
  REVIEW_MANAGER: {
    GOOGLE_PROFILE_ID:
      'https://help.growth99.com/knowledge-base/google-business-profile-permissions-and-review-management-setup',
    GOOGLE_SETUP:
      'https://help.growth99.com/knowledge-base/add-your-website-to-your-google-business-profile',
    YELP_SETUP:
      'https://support.growth99.com/portal/en/kb/articles/how-to-find-the-yelp-url-for-the-5-star-review-configuration-22-2-2023',
    FACE_BOOK_SETUP:
      'https://support.growth99.com/portal/en/kb/articles/how-to-find-the-facebook-url-for-the-5-star-review-configuration',
    DEMAND_FORCE_SETUP:
      'https://support.growth99.com/portal/en/kb/articles/how-to-find-the-demand-force-url-for-the-5-star-review-configuration',
  },

  /**
   * File Management Documentation
   */
  FILE_MANAGEMENT: {
    MANAGING_FILES: 'https://help.growth99.com/knowledge-base/managing-files',
  },
} as const;

/**
 * Type for help documentation keys
 */
export type HelpDocsKey = keyof typeof HELP_DOCS;
